function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useRef, useState } from "react";
var CardWithAccordion = function CardWithAccordion(_ref) {
  var id = _ref.id,
    title = _ref.title,
    defaultState = _ref.defaultState,
    children = _ref.children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    accordionIconActive = _useState2[0],
    setAccordionIconActive = _useState2[1];
  var accordionBodyRef = useRef();
  var toggleAccordionIconState = function toggleAccordionIconState() {
    return setAccordionIconActive(!accordionIconActive);
  };
  useEffect(function () {
    var classToAdd = {
      open: 'show',
      closed: 'collapse'
    };
    var classToRemove = {
      open: 'collapse',
      closed: 'show'
    };
    accordionBodyRef.current.classList.add(classToAdd[defaultState] || '');
    accordionBodyRef.current.classList.remove(classToRemove[defaultState] || '');
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "accordion mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion-header px-3 px-sm-4 py-4 border-bottom"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center cursor-pointer",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#".concat(id),
    "aria-controls": id,
    onClick: toggleAccordionIconState
  }, /*#__PURE__*/React.createElement("h5", {
    className: "text-nurture-purple"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "flex-grow-1 text-end"
  }, /*#__PURE__*/React.createElement("button", {
    className: "bg-transparent text-muted border-none",
    type: "button"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: accordionIconActive ? faAngleDown : faAngleRight
  }))))), /*#__PURE__*/React.createElement("div", {
    id: id,
    ref: accordionBodyRef,
    className: "accordion-collapse",
    "aria-labelledby": "headingOne",
    "data-bs-parent": "#accordionExample"
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion-body p-0 p-sm-3"
  }, children))));
};
CardWithAccordion.defaultProps = {
  defaultState: 'open'
};
export default CardWithAccordion;